'use client';

import { useQuery } from '@tanstack/react-query';
import {
  EXTERNAL_LAB_STAGES,
  INTERNAL_LAB_STAGES,
  PIPELINE_STAGES
} from '../constants';
import { workflowQueries } from '../services/workflow.queries';

export interface PipelineOrder {
  stages: readonly string[];
  external: readonly string[];
  internal: readonly string[];
}

const FALLBACK: PipelineOrder = {
  stages: PIPELINE_STAGES,
  external: EXTERNAL_LAB_STAGES,
  internal: INTERNAL_LAB_STAGES
};

/**
 * The pipeline order from the server, falling back to the bundled copy while
 * the request is in flight or if it fails — a stage list never renders empty.
 */
export function useWorkflowStages(): PipelineOrder {
  const { data } = useQuery(workflowQueries.stages());
  const body = data?.data;

  return body?.stages?.length
    ? { stages: body.stages, external: body.external, internal: body.internal }
    : FALLBACK;
}

/** Position of `stage` in `order`, or -1 when the stage is unknown. */
export function stageIndex(order: readonly string[], stage: string): number {
  return order.indexOf(stage);
}
